import { Component } from '@angular/core';
import { StandaloneBaseComponent } from '../base/standalone-base.component';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-maintenance-base',
    templateUrl: './maintenance-base.component.html',
    standalone: false
})
export class MaintenanceBaseComponent extends StandaloneBaseComponent {
  public constructor() {
    super();
    let title = $localize`:@@MaintenanceTitle:Maintenance`;
    this.titleSet(title);
    this.metaDescriptionSet([{ key: "page", value: title }]);
  }

  public contactOpen() {
    ServiceLocator.injector.get(Router).navigate(["contact-request"]);
  }
}
